import { render, staticRenderFns } from "./catalogs.vue?vue&type=template&id=3f47601e&scoped=true&lang=pug&"
import script from "./catalogs.vue?vue&type=script&lang=js&"
export * from "./catalogs.vue?vue&type=script&lang=js&"
import style0 from "./catalogs.vue?vue&type=style&index=0&id=3f47601e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f47601e",
  null
  
)

export default component.exports